/**
 * Anexa um LocalVideoTrack ou RemoteVideoTrack a um contentor.
 * - `controls`: barra nativa (play/pause, volume, ecrã inteiro), alinhado ao VideoPlayer da app.
 * - `muted`: ajuda autoplay em HTTPS; o utilizador pode alterar nos controlos se existir áudio.
 *
 * @param {object} [opts]
 * @param {boolean} [opts.controls=true]
 * @param {boolean} [opts.muted=true]
 */
export function attachVideoTrackInContainer(container, track, logPrefix = '[PetLive][TwilioVideo]', opts = {}) {
    const { controls = true, muted = true } = opts;
    if (!container || !track || track.kind !== 'video') {
        return null;
    }
    container.innerHTML = '';
    const el = track.attach();
    container.appendChild(el);
    if (!(el instanceof HTMLVideoElement)) {
        return el;
    }
    if (controls) {
        el.controls = true;
    }
    el.muted = muted;
    el.setAttribute('playsinline', '');
    el.setAttribute('webkit-playsinline', '');
    el.playsInline = true;
    el.autoplay = true;

    const tryPlay = () => {
        const p = el.play();
        if (p && typeof p.catch === 'function') {
            p.catch((e) => console.warn(logPrefix, 'video.play()', e && e.message));
        }
    };
    tryPlay();
    if (typeof track.once === 'function') {
        track.once('started', tryPlay);
    }
    return el;
}
